import React from "react";

import { sidebarOnClicks, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Glyphicon } from "react-bootstrap";
import { Navigation, Link, History } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar";
import Validate from "js/utilities/validate";
import Api from "js/utilities/fnapi-client";
import * as config from "../../config";
import UserHandler from "js/utilities/user-handler";
import LogErrrorsToZoomCloud from "js/utilities/log-errors-to-zc"
import TextRow from "../elements/text-row.jsx";
import SelectRow from "../elements/select-row.jsx";
import RadioRow from "../elements/radio-row.jsx";
import CheckRow from "../elements/check-row.jsx";
import TextAreaRow from "../elements/text-area-row.jsx";
import serialize from "form-serialize";


export default React.createClass({

  mixins: [Navigation],

  displayName: "Request a Quote",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState() {
    var scrollToElement = initDeepLinkData(this.props);
    // This component is used for the Request a Quote AND Request Server Access
    // We're determining which based on the path
    // There is a cleaner reactier way to do this, but the guides I followed didn't work...
    // Might be because of our legacy version of react, didn't stick around to find out
    return {
      source: window.location.href.indexOf("server-access") !== -1 ? "server_access" : "quote_request",
      error: "",
      success: "",
      loading: false,
      companyType: "",
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
    sidebarOnClicks()
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  onChildChanged() {
    this.fetchUsers();
  },

  updateField: function(event){
      let stateObject = function() {
          let returnObj = {};
          returnObj[this.target.id] = this.target.value;
          return returnObj;
      }.bind(event)();
      this.setState( stateObject );
  },

  render: function() {
      return (
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">
              <section>
                <div className="title">
                  <Glyphicon glyph="user" />
                  {this.state.source === "quote_request" &&
                    <h2 id="request-pricing-quote">Request a Pricing Quote</h2>
                  }
                  {this.state.source === "server_access" &&
                    <h2 id="request-server-access">Request Server Access</h2>
                  }
                </div>
                <p>Please fill out the following information about your company, app(s), and use case and we will get back to you as soon as possible.</p>
                <br />
                <hr />
              </section>

              <section className="form-section quote-form">
                <form autoComplete="off" onSubmit={this.handleSubmit} className="form-element" id="quote-request-form" >

                  <h4>General Information</h4>
                  <hr/>


                  <TextRow label="Company Name" field="company" requiredField="1" placeholder="Please provide Company Name" onKeyUp={this.updateField} />
                  <SelectRow field="country" label='Country' requiredField="1" placeholder="Please select Country" options={countryOptions} onChange={this.updateField} />
                  <SelectRow field="industry" label='Industry' requiredField="1" placeholder="Please select Industry" options={industryOptions} onChange={this.updateField} />
                  <SelectRow field="companyType" label='Company Type' requiredField="1" placeholder="Please select Company Type" options={companyTypeOptions} onChange={this.updateField}/>

                  {(this.state.companyType === "Other") && <TextRow field="companyTypeOther" label='Please specify company type' requiredField="1" placeholder="Please specify company type" onChange={this.updateField} /> }
                  {(this.state.companyType === "Small Business") && <RadioRow field="smallBusinessCompanySize" label="Are your current revenues over $10M/yr?" options={companySizeOptions} requiredField="1" placeholder="Are your current revenues over $10M/yr?"  onChange={this.updateField}/>}
                  {(this.state.companyType === "Start-up") && <RadioRow field="startUpCompanySize" label="Are your (or your parent company&#39;s) current revenues over $10M/yr?" options={companySizeOptions} requiredField="1" placeholder="Are your (or your parent company&#39;s) current revenues over $10M/yr?" onChange={this.updateField}/> }


                  <h4>Contact Information</h4>
                  <hr/>
                  <TextRow field="name" label='Name' requiredField="1" placeholder="Please provide Contact Name" onChange={this.updateField} />
                  <TextRow field="phone" label='Phone' requiredField="1" placeholder="Please provide Contact Phone" onChange={this.updateField} />
                  <TextRow field="email" label='Email' requiredField="1" placeholder="Please provide Contact Email" onChange={this.updateField} />


                  <h4>Usage Details</h4>
                  <hr/>
                  <RadioRow field="organizationType" label="You are" options={organizationTypeOptions} requiredField="1" onChange={this.updateField} />
                  <TextAreaRow field="useCase" label='Please Describe Your Use Case' rows="4" requiredField="1" placeholder="Please Describe Your Use Case" onChange={this.updateField}/>


                  <h4>Requested Features</h4>
                  <hr/>
                  <RadioRow field="biometricFunction" label="Biometric Function Required" options={biometricFunctionOptions} requiredField="1" onChange={this.updateField} />
                  <CheckRow field="additionalFeatures" label="Additional Features" options={additionalFeaturesOptions} requiredField="1" onChange={this.updateField} />


                  <h4 className="clearfix">Usage Projections</h4>
                  <hr/>
                  <SelectRow field="projectedUsers" label='Projected Individual Users For First Year' options={projectedUsersOptions} requiredField="1" placeholder="Projected Individual Users For First Year" onChange={this.updateField} />
                  <RadioRow field="timeFrame" label="Launch Timeframe" options={timeFrameOptions} requiredField="1" onChange={this.updateField} />

                  <input type="hidden" name="form" value={this.state.source} />

                  <div className="btn-new-container">
                    <button type="submit" className="btn-new submit-btn" disabled={this.state.loading ? "disabled" : ""}>
                      {!this.state.loading ? <span>Submit</span> : <span>Processing...</span> }
                    </button>
                  </div>
                </form>
                <br/>
                {this.state.error != "" ? <p className="error-message">{this.state.error}</p> : "" }
                {this.state.success != "" ? <p className="success">{this.state.success}</p> : "" }
              </section>
              <SDKSidebar menuType="main" title="Quote"/>
            </div>
          </div>
        </div>
        );
      },

      getAllFormValues: function(){
          let form = document.querySelector("#quote-request-form");
          return serialize(form, {hash: true});
      },

      handleSubmit: function(event) {
        event.preventDefault();

        let formData = this.getAllFormValues();

        let data = {
            subject: formData.organizationType + " - Quote Request: " + formData.company,
            class: "quote_request",
            messageJson: formData,
            email: formData.email,
            name: formData.name
        };

        if (!Validate.email(data.email)) {
            this.setState({error: "Please enter a valid email address", success: ""});
            window.scrollTo(0, 0);
            return
        }

        this.setState({error: "", loading: true});

        Api.post("contact",data).then((response) => {
            document.getElementById("quote-request-form").reset();
            this.setState({error: "", success: "Thank you for your submission, we will contact you as soon as possible with more information.", loading: false, companyType:""});
        }).catch( (error) => {
            this.setState({error: error.message, success: "", loading: false});
        });
      },
  });


    //
    // Below are all of the options
    //

    const industryOptions =[
        {"label": "Financial Services", "value": "Financial Services"},
        {"label": "Public Sector", "value": "Public Sector"},
        {"label": "Transportation", "value": "Transportation"},
        {"label": "Healthcare", "value": "Healthcare"},
        {"label": "Other", "value": "Other"}
    ];

    const companyTypeOptions =[
        {"label": "Large Corporation", "value": "Large Corporation"},
        {"label": "Government Agency", "value": "Government Agency"},
        {"label": "Small Business", "value": "Small Business"},
        {"label": "Educational Institution", "value": "Educational Institution"},
        {"label": "Non-Profit Organization", "value": "Non-Profit Organization"},
        {"label": "Start-up", "value": "Start-up"},
        {"label": "Consulting On Behalf of Client", "value": "Consulting On Behalf of Client"},
        {"label": "Technology Analyst", "value": "Technology Analyst"},
        {"label": "Other", "value": "Other"},
    ];

    const companySizeOptions = [
        {"label": "Yes", "value": "More than 10M"},
        {"label": "No", "value": "Less than 10M"},
    ];

    const organizationTypeOptions = [
        {"value": "Customer", "label": "An Organization with it's own Apps & End Users"},
        {"value": "Partner", "label": "A Company who wants to Resell FaceTec SDKs to other companies"},
    ];

    const biometricFunctionOptions = [
        {"value": "Matching and Liveness", "label": "3D Face Matching + 3D Liveness Detection"},
        {"value": "Liveness Only", "label": "3D Liveness Check Only", "hint": "No Face Matching"},
    ];

    const biometricProcessingLocationOptions = [
        {"value": "Facetec", "label": "FaceTec-Hosted Solution: Via our Testing API"},
        {"value": "Customer", "label": "Customer-Hosted Solution: Your Servers Store & Process FaceMaps"},
    ];

    const additionalFeaturesOptions = [
        {"value": "ID Document Matching", "label": "Compare User's Face to their Photo ID Document"},
        {"value": "Audit Trail", "label": "Audit Trail Image For Each Session"},
        {"value": "Framework Plugin", "label": "Framework Plug-In", "hint": "Xamarin, Cordova, etc."},
        {"value": "ID Face Comparison", "label": "Compare Live User's Face to Photo ID Document"},
        {"value": "Cross Platform Support", "label": "Cross Platform Support", "hint": "Webcam, ATM, IoT, etc."},
        {"value": "Blockchain Storage", "label": "Blockchain 3D FaceMap Storage"},
        {"value": "1:n matching", "label": "1:N Face Search for Deduplication & Fraud Detection"},
    ];

    const projectedUsersOptions = [
        {"value": "100k or less", "label": "<100,000"},
        {"value": "100K-200K", "label": "100K-200K"},
        {"value": "200K-500K", "label": "200K-500K"},
        {"value": "500K-1M", "label": "500K-1M"},
        {"value": "1M-5M", "label": "1M-5M"},
        {"value": "5M-10M", "label": "5M-10M"},
        {"value": "10M-20M", "label": "10M-20M"},
        {"value": "More than 20M", "label": "20M+"},
    ];

    const timeFrameOptions = [
        {"value": "Immediately", "label": "Immediately"},
        {"value": "Next Month", "label": "Next Month"},
        {"value": "Within 3 Months", "label": "Next 3 Months"},
        {"value": "Within 6 Months", "label": "Next 6 Months"},
        {"value": "This year or longer", "label": "Over 6 Months"},
    ];

    const countryOptions = [
        {"label": "United States", "value": "US"},
        {"label": "Afghanistan", "value": "AF"},
        {"label": "Åland Islands", "value": "AX"},
        {"label": "Albania", "value": "AL"},
        {"label": "Algeria", "value": "DZ"},
        {"label": "American Samoa", "value": "AS"},
        {"label": "AndorrA", "value": "AD"},
        {"label": "Angola", "value": "AO"},
        {"label": "Anguilla", "value": "AI"},
        {"label": "Antarctica", "value": "AQ"},
        {"label": "Antigua and Barbuda", "value": "AG"},
        {"label": "Argentina", "value": "AR"},
        {"label": "Armenia", "value": "AM"},
        {"label": "Aruba", "value": "AW"},
        {"label": "Australia", "value": "AU"},
        {"label": "Austria", "value": "AT"},
        {"label": "Azerbaijan", "value": "AZ"},
        {"label": "Bahamas", "value": "BS"},
        {"label": "Bahrain", "value": "BH"},
        {"label": "Bangladesh", "value": "BD"},
        {"label": "Barbados", "value": "BB"},
        {"label": "Belarus", "value": "BY"},
        {"label": "Belgium", "value": "BE"},
        {"label": "Belize", "value": "BZ"},
        {"label": "Benin", "value": "BJ"},
        {"label": "Bermuda", "value": "BM"},
        {"label": "Bhutan", "value": "BT"},
        {"label": "Bolivia", "value": "BO"},
        {"label": "Bosnia and Herzegovina", "value": "BA"},
        {"label": "Botswana", "value": "BW"},
        {"label": "Bouvet Island", "value": "BV"},
        {"label": "Brazil", "value": "BR"},
        {"label": "British Indian Ocean Territory", "value": "IO"},
        {"label": "Brunei Darussalam", "value": "BN"},
        {"label": "Bulgaria", "value": "BG"},
        {"label": "Burkina Faso", "value": "BF"},
        {"label": "Burundi", "value": "BI"},
        {"label": "Cambodia", "value": "KH"},
        {"label": "Cameroon", "value": "CM"},
        {"label": "Canada", "value": "CA"},
        {"label": "Cape Verde", "value": "CV"},
        {"label": "Cayman Islands", "value": "KY"},
        {"label": "Central African Republic", "value": "CF"},
        {"label": "Chad", "value": "TD"},
        {"label": "Chile", "value": "CL"},
        {"label": "China", "value": "CN"},
        {"label": "Christmas Island", "value": "CX"},
        {"label": "Cocos (Keeling) Islands", "value": "CC"},
        {"label": "Colombia", "value": "CO"},
        {"label": "Comoros", "value": "KM"},
        {"label": "Congo", "value": "CG"},
        {"label": "Congo, The Democratic Republic of the", "value": "CD"},
        {"label": "Cook Islands", "value": "CK"},
        {"label": "Costa Rica", "value": "CR"},
        {"label": "Cote D'Ivoire", "value": "CI"},
        {"label": "Croatia", "value": "HR"},
        {"label": "Cuba", "value": "CU"},
        {"label": "Cyprus", "value": "CY"},
        {"label": "Czech Republic", "value": "CZ"},
        {"label": "Denmark", "value": "DK"},
        {"label": "Djibouti", "value": "DJ"},
        {"label": "Dominica", "value": "DM"},
        {"label": "Dominican Republic", "value": "DO"},
        {"label": "Ecuador", "value": "EC"},
        {"label": "Egypt", "value": "EG"},
        {"label": "El Salvador", "value": "SV"},
        {"label": "Equatorial Guinea", "value": "GQ"},
        {"label": "Eritrea", "value": "ER"},
        {"label": "Estonia", "value": "EE"},
        {"label": "Ethiopia", "value": "ET"},
        {"label": "Falkland Islands (Malvinas)", "value": "FK"},
        {"label": "Faroe Islands", "value": "FO"},
        {"label": "Fiji", "value": "FJ"},
        {"label": "Finland", "value": "FI"},
        {"label": "France", "value": "FR"},
        {"label": "French Guiana", "value": "GF"},
        {"label": "French Polynesia", "value": "PF"},
        {"label": "French Southern Territories", "value": "TF"},
        {"label": "Gabon", "value": "GA"},
        {"label": "Gambia", "value": "GM"},
        {"label": "Georgia", "value": "GE"},
        {"label": "Germany", "value": "DE"},
        {"label": "Ghana", "value": "GH"},
        {"label": "Gibraltar", "value": "GI"},
        {"label": "Greece", "value": "GR"},
        {"label": "Greenland", "value": "GL"},
        {"label": "Grenada", "value": "GD"},
        {"label": "Guadeloupe", "value": "GP"},
        {"label": "Guam", "value": "GU"},
        {"label": "Guatemala", "value": "GT"},
        {"label": "Guernsey", "value": "GG"},
        {"label": "Guinea", "value": "GN"},
        {"label": "Guinea-Bissau", "value": "GW"},
        {"label": "Guyana", "value": "GY"},
        {"label": "Haiti", "value": "HT"},
        {"label": "Heard Island and Mcdonald Islands", "value": "HM"},
        {"label": "Holy See (Vatican City State)", "value": "VA"},
        {"label": "Honduras", "value": "HN"},
        {"label": "Hong Kong", "value": "HK"},
        {"label": "Hungary", "value": "HU"},
        {"label": "Iceland", "value": "IS"},
        {"label": "India", "value": "IN"},
        {"label": "Indonesia", "value": "ID"},
        {"label": "Iran, Islamic Republic Of", "value": "IR"},
        {"label": "Iraq", "value": "IQ"},
        {"label": "Ireland", "value": "IE"},
        {"label": "Isle of Man", "value": "IM"},
        {"label": "Israel", "value": "IL"},
        {"label": "Italy", "value": "IT"},
        {"label": "Jamaica", "value": "JM"},
        {"label": "Japan", "value": "JP"},
        {"label": "Jersey", "value": "JE"},
        {"label": "Jordan", "value": "JO"},
        {"label": "Kazakhstan", "value": "KZ"},
        {"label": "Kenya", "value": "KE"},
        {"label": "Kiribati", "value": "KI"},
        {"label": "Korea, Democratic People's Republic of", "value": "KP"},
        {"label": "Korea, Republic of", "value": "KR"},
        {"label": "Kuwait", "value": "KW"},
        {"label": "Kyrgyzstan", "value": "KG"},
        {"label": "Lao People's Democratic Republic", "value": "LA"},
        {"label": "Latvia", "value": "LV"},
        {"label": "Lebanon", "value": "LB"},
        {"label": "Lesotho", "value": "LS"},
        {"label": "Liberia", "value": "LR"},
        {"label": "Libyan Arab Jamahiriya", "value": "LY"},
        {"label": "Liechtenstein", "value": "LI"},
        {"label": "Lithuania", "value": "LT"},
        {"label": "Luxembourg", "value": "LU"},
        {"label": "Macao", "value": "MO"},
        {"label": "Macedonia, The Former Yugoslav Republic of", "value": "MK"},
        {"label": "Madagascar", "value": "MG"},
        {"label": "Malawi", "value": "MW"},
        {"label": "Malaysia", "value": "MY"},
        {"label": "Maldives", "value": "MV"},
        {"label": "Mali", "value": "ML"},
        {"label": "Malta", "value": "MT"},
        {"label": "Marshall Islands", "value": "MH"},
        {"label": "Martinique", "value": "MQ"},
        {"label": "Mauritania", "value": "MR"},
        {"label": "Mauritius", "value": "MU"},
        {"label": "Mayotte", "value": "YT"},
        {"label": "Mexico", "value": "MX"},
        {"label": "Micronesia, Federated States of", "value": "FM"},
        {"label": "Moldova, Republic of", "value": "MD"},
        {"label": "Monaco", "value": "MC"},
        {"label": "Mongolia", "value": "MN"},
        {"label": "Montserrat", "value": "MS"},
        {"label": "Morocco", "value": "MA"},
        {"label": "Mozambique", "value": "MZ"},
        {"label": "Myanmar", "value": "MM"},
        {"label": "Namibia", "value": "NA"},
        {"label": "Nauru", "value": "NR"},
        {"label": "Nepal", "value": "NP"},
        {"label": "Netherlands", "value": "NL"},
        {"label": "Netherlands Antilles", "value": "AN"},
        {"label": "New Caledonia", "value": "NC"},
        {"label": "New Zealand", "value": "NZ"},
        {"label": "Nicaragua", "value": "NI"},
        {"label": "Niger", "value": "NE"},
        {"label": "Nigeria", "value": "NG"},
        {"label": "Niue", "value": "NU"},
        {"label": "Norfolk Island", "value": "NF"},
        {"label": "Northern Mariana Islands", "value": "MP"},
        {"label": "Norway", "value": "NO"},
        {"label": "Oman", "value": "OM"},
        {"label": "Pakistan", "value": "PK"},
        {"label": "Palau", "value": "PW"},
        {"label": "Palestinian Territory, Occupied", "value": "PS"},
        {"label": "Panama", "value": "PA"},
        {"label": "Papua New Guinea", "value": "PG"},
        {"label": "Paraguay", "value": "PY"},
        {"label": "Peru", "value": "PE"},
        {"label": "Philippines", "value": "PH"},
        {"label": "Pitcairn", "value": "PN"},
        {"label": "Poland", "value": "PL"},
        {"label": "Portugal", "value": "PT"},
        {"label": "Puerto Rico", "value": "PR"},
        {"label": "Qatar", "value": "QA"},
        {"label": "Reunion", "value": "RE"},
        {"label": "Romania", "value": "RO"},
        {"label": "Russian Federation", "value": "RU"},
        {"label": "RWANDA", "value": "RW"},
        {"label": "Saint Helena", "value": "SH"},
        {"label": "Saint Kitts and Nevis", "value": "KN"},
        {"label": "Saint Lucia", "value": "LC"},
        {"label": "Saint Pierre and Miquelon", "value": "PM"},
        {"label": "Saint Vincent and the Grenadines", "value": "VC"},
        {"label": "Samoa", "value": "WS"},
        {"label": "San Marino", "value": "SM"},
        {"label": "Sao Tome and Principe", "value": "ST"},
        {"label": "Saudi Arabia", "value": "SA"},
        {"label": "Senegal", "value": "SN"},
        {"label": "Serbia and Montenegro", "value": "CS"},
        {"label": "Seychelles", "value": "SC"},
        {"label": "Sierra Leone", "value": "SL"},
        {"label": "Singapore", "value": "SG"},
        {"label": "Slovakia", "value": "SK"},
        {"label": "Slovenia", "value": "SI"},
        {"label": "Solomon Islands", "value": "SB"},
        {"label": "Somalia", "value": "SO"},
        {"label": "South Africa", "value": "ZA"},
        {"label": "South Georgia and the South Sandwich Islands", "value": "GS"},
        {"label": "Spain", "value": "ES"},
        {"label": "Sri Lanka", "value": "LK"},
        {"label": "Sudan", "value": "SD"},
        {"label": "Surilabel", "value": "SR"},
        {"label": "Svalbard and Jan Mayen", "value": "SJ"},
        {"label": "Swaziland", "value": "SZ"},
        {"label": "Sweden", "value": "SE"},
        {"label": "Switzerland", "value": "CH"},
        {"label": "Syrian Arab Republic", "value": "SY"},
        {"label": "Taiwan, Province of China", "value": "TW"},
        {"label": "Tajikistan", "value": "TJ"},
        {"label": "Tanzania, United Republic of", "value": "TZ"},
        {"label": "Thailand", "value": "TH"},
        {"label": "Timor-Leste", "value": "TL"},
        {"label": "Togo", "value": "TG"},
        {"label": "Tokelau", "value": "TK"},
        {"label": "Tonga", "value": "TO"},
        {"label": "Trinidad and Tobago", "value": "TT"},
        {"label": "Tunisia", "value": "TN"},
        {"label": "Turkey", "value": "TR"},
        {"label": "Turkmenistan", "value": "TM"},
        {"label": "Turks and Caicos Islands", "value": "TC"},
        {"label": "Tuvalu", "value": "TV"},
        {"label": "Uganda", "value": "UG"},
        {"label": "Ukraine", "value": "UA"},
        {"label": "United Arab Emirates", "value": "AE"},
        {"label": "United Kingdom", "value": "GB"},
        {"label": "United States", "value": "US"},
        {"label": "United States Minor Outlying Islands", "value": "UM"},
        {"label": "Uruguay", "value": "UY"},
        {"label": "Uzbekistan", "value": "UZ"},
        {"label": "Vanuatu", "value": "VU"},
        {"label": "Venezuela", "value": "VE"},
        {"label": "Viet Nam", "value": "VN"},
        {"label": "Virgin Islands, British", "value": "VG"},
        {"label": "Virgin Islands, U.S.", "value": "VI"},
        {"label": "Wallis and Futuna", "value": "WF"},
        {"label": "Western Sahara", "value": "EH"},
        {"label": "Yemen", "value": "YE"},
        {"label": "Zambia", "value": "ZM"},
        {"label": "Zimbabwe", "value": "ZW"}
    ];



// WEBPACK FOOTER //
// ./src/js/components/screens/quote.jsx